import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

import FeatureCreatorNewActions from '../../../FeatureCreator/FeatureCreatorNewActions';
import WizardPopupFeaturesExclusionFeature from "./WizardPopupFeaturesExclusionFeature";
import WizardPopupEntitiesExclusionTopFilters from "./WizardPopupEntitiesExclusionTopFilters";
import {filterWizardPopupFeatures, getWizardPopupFeatures} from "./wizardPopupFeaturesFunctions";
import {FormattedMessage} from "react-intl";
import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {setSelectedFilters} from "../../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import {getFeatureExcludedIndex, getFeatureIsChecked, getFeaturesExcludedObject} from "../../wizardFunctions";

const WizardPopupFeaturesExclusion = (props) => {

  const {wizardPopupGroup, loadFeatures, enabledFeatures, loadingFeatures, selectedFilters, setSelectedFilters,
    resetFeatures} = props;

  const [sortedFeatures, setSortedFeatures] = useState([]);

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);
  const {searchText, featuresExcluded} = wizardPopupState;

  useEffect(() => {
    loadFeatures(wizardPopupGroup.groupName, null, false);
    console.log("wizardPopupGroup", wizardPopupGroup);
    return () => {
      setSelectedFilters([]);
      resetFeatures();
    }
  }, [])

  useEffect(() => {
    if (!loadingFeatures && enabledFeatures.length) {
      setSortedFeatures(enabledFeatures.sort((a, b) => {
        return getFeatureIsChecked(a, wizardPopupState)
        > getFeatureIsChecked(b, wizardPopupState) ? -1 : 1
      }));
    }
  }, [enabledFeatures, loadingFeatures])

  useEffect(() => {
    console.log("useEffect useIncluded", wizardPopupGroup.useIncluded);
    if (!loadingFeatures && enabledFeatures.length && !wizardPopupGroup.useIncluded) {
      const renderFeatures = filterWizardPopupFeatures(enabledFeatures, "", []);
      const featuresIncluded = renderFeatures
        .filter(feature => getFeatureExcludedIndex(feature, featuresExcluded) === -1)
        .map(feature => getFeaturesExcludedObject(feature));
      console.log("featuresIncluded useEffect featuresIncluded", featuresIncluded);
      wizardPopupDispatch({
        type: wizardPopupAction,
        payload: {
          useIncluded: true,
          featuresIncluded,
        }
      })
    }
  }, [loadingFeatures])

  if (loadingFeatures) {
    return <div className="ui-loader"/>
  }

  // console.log("enabledFeatures", enabledFeatures);

  if (!sortedFeatures.length) {
    return (
      <div className="fc-filters__empty">
        <FormattedMessage id="wizard.popup.noFeaturesFound"/>
      </div>
    )
  }

  const renderFeatures = filterWizardPopupFeatures(sortedFeatures, searchText, selectedFilters);

  return (
    <div className="wizard-popup">
      <WizardPopupEntitiesExclusionTopFilters renderFeatures={renderFeatures} forFeatures={sortedFeatures}/>
      {renderFeatures.length ? (
        <div className="wizard-features">
          <ul className="wizard-features__list fix-ul">
            {renderFeatures.map(feature => {
              return <WizardPopupFeaturesExclusionFeature feature={feature}
                                                          renderFeatures={renderFeatures}
                                                          key={feature.featureDefinitionId}/>
            })}
          </ul>
        </div>
      ) : (
        <div className="fc-filters__empty">
          <FormattedMessage id="wizard.popup.noFeaturesFoundFilters"/>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup, wizardVisualizer} = store.wizardState;
  let {enabledFeatures, loadingFeatures} = store.featuresCreatorNew;
  let {selectedFilters} = store.featuresFiltersState;

  return {
    loadingFeatures,
    wizardPopupGroup,
    enabledFeatures: getWizardPopupFeatures(enabledFeatures, wizardVisualizer),
    selectedFilters,
  };
};

const mapDispatchToProps = {
  loadFeatures: FeatureCreatorNewActions.loadOnlyEnabledFeatures,
  resetFeatures: FeatureCreatorNewActions.resetFeatures,
  setSelectedFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardPopupFeaturesExclusion)
